<template>
  <div
    v-if="value"
    class="infoBlock"
  >
    <div
      class="label"
      :data-automation="dataAutomation + '-label'"
    >
      {{ label }}
    </div>
    <div :data-automation="dataAutomation + '-value'">
      {{ value }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoBlockText',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    dataAutomation: {
      type: String,
      required: false,
      default: '',
    },
  },
}

</script>
